import { render, staticRenderFns } from "./myAboutDetail.vue?vue&type=template&id=408088c7&scoped=true&"
import script from "./myAboutDetail.vue?vue&type=script&lang=js&"
export * from "./myAboutDetail.vue?vue&type=script&lang=js&"
import style0 from "./myAboutDetail.vue?vue&type=style&index=0&id=408088c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408088c7",
  null
  
)

export default component.exports